import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  template: `<span v-tooltip="{ content: listNames, classes: ['info'], targetClasses: ['it-has-a-tooltip']}" :class="{'font-bold cursor-pointer' : displayValue}" @click="fetchListNames(displayValue)">{{displayValue}}</span>`,
  data: function() {
    return {
      displayValue: '',
      listNames: ''
    };
  },
  beforeMount() {
    this.displayValue = this.params.value;
  },
  methods: {
    async fetchListNames(data) {
      this.listNames = '';
      if (data) {
        let listStat = await axios.post('/leads-list-name', {
          lead_id: this.params.data.id.lead_id
        });
        if (
          listStat &&
          listStat.data &&
          listStat.data.list_names &&
          listStat.data.list_names.length
        ) {
          let index = 0;
          listStat.data.list_names.forEach(ele => {
            if (index == listStat.data.list_names.length - 1) {
              this.listNames += `<p>${ele}</p>`;
            } else {
              this.listNames += `<p>${ele}</p><br/>`;
            }
            index++;
          });
        }
      }
    }
  }
});
